/**
 * Helper to handle cookies in navigator with JS
 */

/**
 * Get Cookie from name
 *
 * @param {?string} cookieName The name of the cookie
 */
export function getCookie(cookieName) {
  // Init searched cookie and list of cookies
  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieList = decodedCookie.split(';');

  // Find specified cookie
  const cookieFound = cookieList
    .map(cookie => {
      return cookie.trim();
    })
    .find(cookieTrimmed => {
      // Return cookie value
      return cookieTrimmed.indexOf(name) === 0;
    });

  // Get value from cookie name
  const cookieValue = cookieFound ? cookieFound.slice(name.length, cookieFound.length) : undefined;

  return cookieValue?.length ? cookieValue : undefined;
}

/**
 * Set Cookie in document
 *
 * Also used to remove with expireDays = -1
 *
 * @param {string} cookies Name of the cookie
 * @param {string} domain Value of the cookie
 *
 */
export function clearCookies(cookies, domain) {
  cookies.forEach(cookie => {
    document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
  });
}
